export enum SubscriptionStatusAmoeba {
  Invited = "invited",
  Started = "started",
  AwaitingLpSignature = "awaiting_lp_signature",
  LpSignatureCompleted = "lp_signature_completed",
  AwaitingComplianceReview = "awaiting_compliance_review",
  ComplianceReviewCompleted = "compliance_review_completed",
  AwaitingStaffReview = "awaiting_staff_review",
  StaffReviewCompleted = "staff_review_completed",
  StaffCountersignCompleted = "staff_countersign_completed",
  Accepted = "accepted",
  Declined = "declined",
  Canceled = "canceled",
}
